import { BlockedIcon } from 'assets/icons';
import { SUPPORT_MAIL } from 'config/index';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface MerchantOrTeamBlockedInfoProps {
  title?: string;
  className?: string;
}

const MerchantOrTeamBlockedInfo: FC<MerchantOrTeamBlockedInfoProps> = ({ title, className }) => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const isTeamBlocked = currentTeam?.isTeamBlocked;
  const isMerchantBlocked = currentTeam?.isMerchantBlockedInTeam;
  const isTemporarilyBlocked = currentTeam?.isTemporarilyBlocked;
  const autoBlockInfo = currentTeam?.autoBlockInfo;

  const defaultHeading = `Your ${isTeamBlocked && !isMerchantBlocked ? 'team' : 'account'} is temporarily on hold.`;
  const heading = isTemporarilyBlocked && autoBlockInfo?.title ? autoBlockInfo.title : defaultHeading;

  return (
    <div className={twMerge('flex h-full flex-col justify-center gap-10 px-6 pt-6 md:gap-36', className)}>
      {title && <div className="text-3xl font-bold text-primaryText">{title}</div>}
      <div className="mx-auto flex w-full grow flex-col items-center px-4 text-center sm:px-2.5">
        <BlockedIcon className="mb-5 shrink-0" />
        <div className="mb-4 text-xl font-bold text-headingGray">{heading}</div>
        <div className="flex flex-col gap-[18px]">
          {isTemporarilyBlocked && autoBlockInfo ? (
            <>
              {autoBlockInfo.subtitle && <div className="text-sbase text-primaryText">{autoBlockInfo.subtitle}</div>}
              {autoBlockInfo.description && (
                <div className="text-sbase text-primaryText">{autoBlockInfo.description}</div>
              )}
            </>
          ) : (
            <>
              {isMerchantBlocked && (
                <div className="text-sbase text-primaryText">
                  Our payment processor has put your account on hold due to high risk transactions associated with the
                  account.
                </div>
              )}
              <div className="text-sbase text-primaryText">
                To re-activate your account, please contact our support team and start accepting payments again.
              </div>
              <div className="text-sbase text-primaryText">
                In case the {isTeamBlocked && !isMerchantBlocked ? 'team' : 'account'} is not{' '}
                {isTeamBlocked && !isMerchantBlocked ? 'removed from hold' : 're-activated'} within 5 days, all pending
                payouts will be refunded back to your customer's card.
              </div>
            </>
          )}
        </div>
        {!isTemporarilyBlocked && (
          <div className="mt-5 text-sbase text-primaryText">
            For further queries, please contact us at{' '}
            <a className="cursor-pointer text-secondary" href={`mailto:${SUPPORT_MAIL}`}>
              {SUPPORT_MAIL}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchantOrTeamBlockedInfo;
